export default __webpack_public_path__ + "static/media/promptPay4.b20c36c4.png";